import IPosition from "@/models/dto/position.dto";
import { ActionType } from "@/models/enum-types/action-type.enum";

import IDeviceStore from "@/models/modelStore/IDeviceStore";
import IDataInfo from "@/models/modelView/IDataInfo";
import DeviceViewData from "@/models/modelView/IDeviceView";
import { ModemStrategy } from "@/strategies/modem.strategy/modem.strategy";
import DeviceUtil from "@/utils/device.util";

export default class AndroidStrategy extends ModemStrategy {
    getExtraAttributes(attributes: any): IDataInfo[] {
        return [
            { title: 'Odo:', value: (attributes.totalDistance / 1000).toFixed(2) + 'Km' },
        ]
    }

    getReportDetails() {
        return null
    }

    customAttributes: any[] = []

    sendCommand() {
        throw new Error("Method not implemented.");
    }

    mapDevice(device: IDeviceStore): DeviceViewData {
        return {
            data_icons: this.mapIcons(device),
            data_info: [{
                title: 'Precisión:',
                value: (device.position?.accuracy.toFixed(2) || '-') + 'm'
            }].concat(this.mapAttributes(device?.position?.attributes, device)),
            icon: device.icon || '0',
            id: device.id,
            plate: device.name,
            time: device.position?.deviceTime || device.position?.serverTime || device.position?.fixTime || '',
            speed: DeviceUtil.formatKnToKmh(device.position?.speed)
        }
    }

    mapIcons(device: IDeviceStore) {
        const array = [{
            classes: ['icon-data', 'battery-gps'],
            src: require('@/assets/img/battery-gps.svg'),
            extra: (device.position?.attributes.batteryLevel || '-') + "%"
        }]
        if (device.position?.attributes?.charge)
            array.push({
                classes: ['icon-data', 'charge'],
                src: require('@/assets/img/charge.svg'),
                extra: ''
            })
        return array
    }

}